module.exports = __webpack_public_path__ + "video-bg--789122dd.svg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/video-bg.svg
// module id = 223
// module chunks = 0